// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_p5-0";
export var animationContainer = "_p5-1";
export var itemPrice = "_p5-a";
export var itemizedContent = "_p5-9";
export var itemizedHeader = "_p5-7";
export var itemizedRow = "_p5-8";
export var itemizedSection = "_p5-6";
export var modalContent = "_p5-2";
export var orderName = "_p5-3";
export var refundOption = "_p5-4";
export var refundOptionsContainer = "_p5-5";
export var shippingLabel = "_p5-b";
export var totalRow = "_p5-c";